module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-instagram-1.f12da5e6.jpg";